import { init } from "../init";
import { JiraSoftwarePage } from "../pages/jira-software-page/jira-software-page";
init(JiraSoftwarePage);
